<section class="login-page auth-page">
  <div class="container-fluid h-100">
    <div class="row align-items-center justify-content-center h-100">
      <div class="col-xl-9 col-lg-8 col-md-8 col-sm-12">
        <div class="auth-card">
          <div class="auth-card-header">
            <img src="assets/images/logo/logo.png" alt="">
          </div>
          <h2 class="title">{{ 'auth.login' | translate }}</h2>
          <h4 class="sub-title">{{ 'auth.login_to_your_account' | translate }}...</h4>

          <div class="form-group alert alert-danger" *ngIf="errorMsg">{{errorMsg}}</div>

          <form [formGroup]="loginForm" (ngSubmit)='login()' autocomplete="off">
            <mat-form-field class="form-group">
              <mat-label>{{ 'forms.username/user_id' | translate }}</mat-label>
              <input matInput autocomplete="off" formControlName="username">
              <mat-error *ngIf="hasError('username', 'required')">{{ 'forms.required' | translate }}</mat-error>
              <mat-error *ngIf="hasError('username', 'minlength')">
                {{ 'forms.invalid_username/user_id' | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="form-group">
              <mat-label>{{ 'forms.password' | translate }}</mat-label>
              <input matInput autocomplete="off" formControlName="password" [type]="hidePassword ? 'password' : 'text'"
                maxlength="50">
              <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-error *ngIf="hasError('password', 'required')">{{ 'forms.required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field class="form-group">
              <mat-label>{{ 'forms.company' | translate }}</mat-label>
              <input matInput autocomplete="off" formControlName="companyCode">
              <mat-error *ngIf="hasError('companyCode', 'required')">{{ 'forms.required' | translate }}</mat-error>
            </mat-form-field>
            <div class="btn-container">
              <button mat-raised-button color="primary" class="w-100" [class.loading]='loading' [disabled]='loading'>
                {{'auth.login_in' | translate }}
              </button>
            </div>

            <div class="password-action mb-3">
              <a>
                {{ 'auth.forget_password' | translate }}
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>